// extracted by mini-css-extract-plugin
export var completed = "timeline-module--completed--88754";
export var dotIsActive = "timeline-module--dotIsActive--02a31";
export var dotsContainer = "timeline-module--dotsContainer--5faa4";
export var isActive = "timeline-module--isActive--7d20b";
export var isLast = "timeline-module--isLast--da10c";
export var last = "timeline-module--last--cb333";
export var lightdot = "timeline-module--lightdot--f8d33";
export var month = "timeline-module--month--37f52";
export var ongoing = "timeline-module--ongoing--0fb1c";
export var planned = "timeline-module--planned--34d41";
export var projectBeginDate = "timeline-module--projectBeginDate--49d2a";
export var projectEndDate = "timeline-module--projectEndDate--1ef13";
export var projectStatus = "timeline-module--projectStatus--b6cab";
export var showdate = "timeline-module--showdate--992ea";
export var timeSlot = "timeline-module--timeSlot--7c96a";
export var timeline = "timeline-module--timeline--6d22d";
export var timelineContainer = "timeline-module--timelineContainer--1e912";
export var timelineWrap = "timeline-module--timelineWrap--c4919";
export var timelineWrapper = "timeline-module--timelineWrapper--dea2e";
export var timeline_items = "timeline-module--timeline_items--5125f";
export var timespan = "timeline-module--timespan--9c458";
export var year = "timeline-module--year--32e66";